import React, { useContext, useEffect, useRef, useState } from 'react'
import { getImages } from '../Components/const'
import FinanceCalculatorForm from '../Components/FinanceCalculator/FinanceCalculatorForm';
import ModalLayout from '../Components/Common/ModalLayout';
import FinanceApplicationModal from '../Components/FinanceCalculator/FinanceApplicationModal';
import { useLocation } from 'react-router-dom';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import SeoMeta from '../Components/Common/SeoMeta';

const FinanceCalculator = () => {
    const location = useLocation();
    const sectionRef = useRef(null);
    const [openFinancingModal,  setOpenFinancingModal] = useState(false);
    const handleFinancingModal = () => {
        setOpenFinancingModal(true);
        document.body.classList.add('body-overflow');
    }
    const closeFinancingModal = () => {
        setOpenFinancingModal(false);
        document.body.classList.remove('body-overflow');
    }
    useEffect(() => {
        if (location.state?.openModal) {
            setOpenFinancingModal(true);
            document.body.classList.add('body-overflow');
            window.history.replaceState({}, document.title);
        }
        if (location.state?.scrollCalculator && sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: 'smooth' });
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);
    UseScrollReveal()
    return (
        <>
            <SeoMeta
                title="Finance Calculator | New & Used McLaren For Sale | McLaren Orlando"
                description="Use this calculator to determine your monthly payments of your future loan. Call McLaren Orlando and speak to a finance specialist today!"
                keywords=""
                ogTitle="Finance Calculator | New & Used McLaren For Sale | McLaren Orlando"
                ogDescription="Use this calculator to determine your monthly payments of your future loan. Call McLaren Orlando and speak to a finance specialist today!"
            />
            <section className='common-banner-wrap'>
                <img src={getImages('calculator-hero-bg.webp')} alt='Financing calculator' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>McLaren Orlando</h4>
                                <h2 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>Financing Available</h2>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <button type='button' onClick={handleFinancingModal} className='theme-btn text-uppercase d-inline-block'>Apply for Financing</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='financing-calculator-wrap d-flex align-items-center'>
                <div className='w-50'>
                    <div className='fc-left h-100'>
                        <div className='mx-width ms-auto'>
                            <h3 className='hpb-xs-title text-uppercase text-start fw-700 mb-2 wow reveal fadeInUp'>Complete Our</h3>
                            <h2 className='lg-title text-uppercase fw-500 mb-4 wow reveal fadeInUp'>Finance Application</h2>
                            <div className='wow reveal fadeInUp'>
                                <p>At McLaren Orlando, our Finance Department is here to ensure you have a luxury experience from start to finish. Our friendly, yet professional team works with both McLaren and local banks to provide you with the options you need to get behind the wheel and start driving.</p>

                                <p>We are focused on helping you enjoy each step of your McLaren ownership, and that starts with us doing all we can to support you in your purchase decision. We offer competitive rates, extended warranties, value-added services to protect and enhance your investment, and more. Our experienced team has forged connections with respected lenders, both nationally and locally, and is ready and waiting to help you to minimize your financial exposure while securing you the McLaren of your dreams.</p>

                                <p>If you are ready to apply for financing with us, please complete the Finance Application in the drop-down menu above. If you have questions about a specific vehicle or credit situation, please feel free to contact our Finance Department at any time to discuss your options. We are here to help you!</p>
                            </div>
                            <div className='mt-4 wow reveal fadeInUp'>
                                    <button type='button' onClick={handleFinancingModal} className='theme-btn text-uppercase d-inline-block'>Apply for Financing</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-50'>
                    <div className='fc-right h-100' ref={sectionRef} id="financeCalculatorBlock">
                        <div className='mxw-480 mx-auto'>
                            <h1 className='lg-title text-uppercase fw-500 mb-4 wow reveal fadeInUp'>FINANCE CALCULATOR</h1>
                            <div className='wow reveal fadeInUp'>
                                <FinanceCalculatorForm/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {openFinancingModal &&
                <ModalLayout open={openFinancingModal} close={closeFinancingModal} darkThemeCls='true' modalWidth={1040}>
                    <FinanceApplicationModal close={closeFinancingModal} />
                </ModalLayout>
            }
        </>
    )
}

export default FinanceCalculator